import React from 'react';

const CoreValues = ({ data }) => {
    return (
        <section className="bg-gray-50 py-14 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                {/* ===== HEADER ===== */}
                <div className="text-center mb-10 md:mb-14">
                    <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">
                        Our Foundation
                    </span>

                    <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mt-2">
                        Core Values
                    </h2>

                    <div className="w-20 h-1 bg-blue-600 mx-auto mt-4 rounded-full"></div>

                    <p className="text-gray-600 mt-4 max-w-xl mx-auto font-medium">
                        The principles that guide our decisions, shape our
                        culture, and define how we work every day.
                    </p>
                </div>

                {/* ===== GRID ===== */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {data.content.map((item, idx) => (
                        <div
                            key={idx}
                            className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-lg transition duration-300"
                        >
                            <div className="flex items-center justify-between mb-4">
                                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-blue-100 text-blue-600 font-bold text-lg">
                                    {idx + 1}
                                </div>
                            </div>

                            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                                {item.title}
                            </h3>

                            <p className="text-sm uppercase tracking-wide text-blue-600 font-semibold mb-3">
                                {item.subtitle}
                            </p>

                            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                                {item.details}
                            </p>
                        </div>
                    ))}
                </div>

                {/* ===== FOOTER TEXT ===== */}
                <div className="text-center mt-10 md:mt-14">
                    <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
                        These values guide everything we do — helping us build
                        meaningful solutions, strong partnerships, and long-term
                        success.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CoreValues;
